module.exports = __webpack_public_path__ + "img/scene5-3.2518739a.jpg";